
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';

import Translatable from '../../../../Translatable';
import SVGIcon from '../../../../../components/SVGIcon';
import SearchBarPanel from './SearchBarPanel';

import { input } from '../../../../../commonStyles.js';
import styles from './styles.js';

import {
    filterActions,
    uiActions
} from '../../../../../pages/Search/actions';

class SearchBarSmall extends Component {
    static propTypes = {
        date: PropTypes.string,
        fullScreenPanel: PropTypes.object.isRequired,
        guests: PropTypes.number,
        location: PropTypes.string.isRequired,
        setTagLabel: PropTypes.func.isRequired,
        tagLabel: PropTypes.string,
        toggleFullScreenPanel: PropTypes.func.isRequired
    }

    state = {
        searchBarPanelOpen: false
    }

    closeSearchBarPanel = () => {
        this.setState({ searchBarPanelOpen: false });
    }

    toggleSearchBarPanel = () => {
        this.setState({ searchBarPanelOpen: !this.state.searchBarPanelOpen });
    }

    render() {
        const { closeSearchBarPanel, toggleSearchBarPanel } = this;
        const { searchBarPanelOpen } = this.state;
        const {
            date,
            tagLabel,
            fullScreenPanel,
            guests,
            location,
            setTagLabel,
            toggleFullScreenPanel
        } = this.props;
        return (
            <div className={css(styles.container, styles.searchBarSmall)}>
                <div className={css(styles.container_fullWidth)}>
                    <button
                        type="button"
                        className={css(styles.button)}
                        onClick={toggleSearchBarPanel}
                    >
                        <span className={css(styles.icon)}>
                            <SVGIcon
                                type="search"
                            />
                        </span>
                        <span className={css(styles.copy)}>
                            {
                                tagLabel ?
                                    tagLabel :
                                    <Translatable
                                        content={{
                                            transKey: 'common.what'
                                        }}
                                    />
                            } · {
                                location ?
                                    location.replace(/--/g, ', ').replace(/-/g, ' ') :
                                    <Translatable
                                        content={{
                                            transKey: 'common.where'
                                        }}
                                    />
                            } · {
                                date ?
                                    date :
                                    <Translatable
                                        content={{
                                            transKey: 'common.when'
                                        }}
                                    />
                            } · {
                                guests ?
                                    <Translatable
                                        content={{
                                            transKey: 'common.guests_count',
                                            count: this.props.guests,
                                            replacements: {
                                                number: this.props.guests
                                            }
                                        }}
                                    /> :
                                    <Translatable
                                        content={{
                                            transKey: 'common.who'
                                        }}
                                    />
                            }
                        </span>
                    </button>
                    <div className={css(input.focusUnderline)} />
                </div>
                {
                    searchBarPanelOpen ?
                        <SearchBarPanel
                            closePanel={closeSearchBarPanel}
                            date={date}
                            tagLabel={tagLabel}
                            fullScreenPanel={fullScreenPanel}
                            guests={guests}
                            location={location.replace(/--/g, ', ').replace(/-/g, ' ')}
                            setTagLabel={setTagLabel}
                            toggleFullScreenPanel={toggleFullScreenPanel}
                        /> : null
                }
            </div>
        );
    }
}

const mapStateToProps = state => ({
    date: state.searchParams.date ? state.searchParams.date : '',
    fullScreenPanel: state.fullScreenPanel,
    guests: state.searchParams.guests,
    location: state.searchParams.location,
    tagLabel: state.tagLabel
});

const mapDispatchToProps = dispatch => {
    return {
        selectGuests: value => {
            dispatch(filterActions.selectGuests(value));
        },
        setTagLabel: tagLabel => {
            dispatch(filterActions.setTagLabel(tagLabel));
        },
        toggleFullScreenPanel: () => {
            dispatch(uiActions.toggleFullScreenPanel());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchBarSmall);



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/SearchBar/SearchBarSmall/SearchBarSmall.jsx